import React from 'react'

export default function NotFound() {
  return (
    <div style={{background:''}}>
        404 - Page Not Found
    </div>
  )
}
